import React, { useState } from 'react';
import styles from './Tab.module.scss';

export interface ITabsProps {
    children: React.ReactNode[];
}

export function Tabs(props: ITabsProps) {
    const { children } = props;

    const [selectedTab, setSelectedTab] = useState(0);

    return (
        <div className={styles.tabRoot}>
            <ul className={styles.tabUl}>
                <TabTitle 
                    title="Join game" 
                    onClick={() => setSelectedTab(0)}
                    isActiveTab={selectedTab === 0}
                />
                <TabTitle 
                    title="Host game" 
                    onClick={() => setSelectedTab(1)}
                    isActiveTab={selectedTab === 1}
                />
            </ul>
            {children[selectedTab]}
        </div>
    );
}

export interface ITabContentProps extends React.PropsWithChildren {}

export function TabContent(props: ITabContentProps) {
    return <div>{props.children}</div>;
}

export interface ITabTitleProps {
    title: string;
    onClick?: () => void;
    isActiveTab?: boolean;
}

export function TabTitle(props: ITabTitleProps) {
    const { title, onClick, isActiveTab } = props;
    return (
        <li className={styles.tab}>
            <button onClick={onClick} className={`${isActiveTab ? styles.activeTab : ''} ${styles.tabButton}`}>{title}</button>
        </li>
    );
}